import { Row, Col, Card, Button, Typography, Input, Pagination } from "antd";
import { useEffect, useState } from "react";
import constant from "../config/constant";
import { HistoryOutlined, LineChartOutlined } from "@ant-design/icons";
import { getDevicesAPI } from "../api/devices";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const { Title } = Typography;
const { Search } = Input;
function Devices() {
  const [users, setUsers] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    _getDevices();
  }, []);

  const _getDevices = async (page = 1, pageSize = 10, name = "") => {
    setLoading(true);
    try {
      const params = {
        page: page,
        limit: pageSize,
      };

      if (name.trim()) {
        params.name = name;
      }

      const res = await getDevicesAPI(params);
      if (res?.statusCode === constant.RESPONSE_CODE.SUCCESS) {
        setUsers(res?.data?.records || []);
        setTotalRecords(res?.data?.totalRecords || 0);
        setPagination((prev) => ({
          ...prev,
          total: parseInt(res?.data?.totalRecords || 0),
        }));
      }
    } catch (error) {
      console.error("Failed to fetch devices:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    _getDevices(pagination.current, pagination.pageSize);
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
    _getDevices(1, pagination.pageSize, value);
  };

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={`Figo Devices (${users.length}/${totalRecords})`}
              extra={
                <Search
                  placeholder="Search by name"
                  allowClear
                  enterButton="Search"
                  style={{ width: 300 }}
                  onSearch={handleSearch}
                  className="custom-search"
                />
              }
            >
              <div className="ant-list-box table-responsive m-25">
                <table className="width-100">
                  <thead>
                    <tr>
                      <th>
                        <div className="text-center">Index</div>
                      </th>
                      <th>
                        <div className="text-center">Name</div>
                      </th>
                      <th>
                        <div className="text-center">Desire Temp</div>
                      </th>
                      <th>
                        <div className="text-center">Current Temp</div>
                      </th>
                      <th>
                        <div className="text-center">Last Ping At</div>
                      </th>
                      <th>
                        <div className="text-center">Connection</div>
                      </th>
                      <th>
                        <div className="text-center">Current Mode</div>
                      </th>
                      <th>
                        <div className="text-center">Current Firmware</div>
                      </th>
                      <th>
                        <div className="text-center">Total Usages</div>
                      </th>
                      <th>
                        <div className="text-center">Connected Account</div>
                      </th>
                      <th>
                        <div className="text-center">Actions</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((d, index) => (
                      <tr key={index}>
                        <td>
                          <div className="text-xs text-center">
                            {(pagination.current - 1) * pagination.pageSize +
                              index +
                              1}
                          </div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            <Title level={5}>{d?.full_name}</Title>
                          </div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            {d?.temperature}
                          </div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            {d?.last_temp?.temp_in_f}
                          </div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            {d?.last_temp?.created_at
                              ? moment(d?.last_temp?.created_at).format("lll")
                              : "NA"}
                          </div>
                        </td>
                        <td>
                          <div
                            className="text-xs text-center"
                            style={{
                              color:
                                d?.device_connection_state === "connected"
                                  ? "green"
                                  : "red",
                            }}
                          >
                            {d?.device_connection_state}
                          </div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            {d?.device_state}
                          </div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            {d?.firmware_version}
                          </div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            {d?.total_usage}
                          </div>
                        </td>
                        <td>
                          <div className="text-xs text-center">{d?.email}</div>
                        </td>

                        <td>
                          <div className="text-xs text-center">
                            <Button
                              type="dashed"
                              style={{ marginLeft: 10 }}
                              onClick={() =>
                                navigate("/deviceGraph", {
                                  device_id: d?.id,
                                })
                              }
                            >
                              <LineChartOutlined style={{ fontSize: "16px" }} />
                              Temp Graph
                            </Button>
                            <Button
                              type="dashed"
                              className="darkbtn"
                              style={{ marginLeft: 10 }}
                              onClick={() =>
                                navigate("/deviceLogs", {
                                  device_id: d?.id,
                                })
                              }
                            >
                              <HistoryOutlined style={{ fontSize: "16px" }} />
                              Logs
                            </Button>
                            <Button
                              type="primary"
                              style={{ marginLeft: 10 }}
                              onClick={() =>
                                navigate("/deviceDetails", {
                                  device_id: d?.id,
                                })
                              }
                            >
                              Details
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{ marginTop: 16, textAlign: "right" }}>
                  <Pagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    onChange={(page, pageSize) => {
                      _getDevices(page, pageSize, searchQuery);
                      setPagination((prev) => ({
                        ...prev,
                        current: page,
                        pageSize: pageSize,
                      }));
                    }}
                    onShowSizeChange={(current, size) => {
                      _getDevices(1, size);
                      setPagination((prev) => ({
                        ...prev,
                        current: 1,
                        pageSize: size,
                      }));
                    }}
                    showSizeChanger
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`
                    }
                  />
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Devices;
